import { useMemo } from "react";
import { X } from "lucide-react";
import FilterSelect from "../../components/FilterSelect";

function studentName(child) {
  return `${child?.firstName || ""} ${child?.lastName || ""}`.trim() || "Student";
}

const TYPE_OPTIONS = [
  { value: "", label: "All posts" },
  { value: "CLASS", label: "Class posts" },
  { value: "CHILD", label: "Child posts" },
];

function PostFeedFilters({
  filters,
  onChange,
  activities = [],
  classes = [],
  children = [],
  loadingActivities,
  loadingClasses,
  loadingChildren,
}) {
  const hasActiveFilter = Boolean(
    filters.type || filters.classroom || filters.child || filters.activity
  );

  const activityOptions = useMemo(
    () => [
      { value: "", label: "All activities" },
      ...activities.map((item) => ({ value: item._id, label: item.title || "Activity" })),
    ],
    [activities]
  );

  const classOptions = useMemo(
    () => [
      { value: "", label: "All classes" },
      ...classes.map((item) => ({
        value: item._id,
        label: item.classroomGrade
          ? `${item.classroomName || "Class"} · Grade ${item.classroomGrade}`
          : item.classroomName || "Class",
      })),
    ],
    [classes]
  );

  const childOptions = useMemo(
    () => [
      { value: "", label: "All students" },
      ...children.map((item) => ({ value: item._id, label: studentName(item) })),
    ],
    [children]
  );

  const update = (key, nextValue) => {
    onChange({ ...filters, [key]: nextValue });
  };

  const clearAll = () => {
    onChange({ type: "", classroom: "", child: "", activity: "" });
  };

  return (
    <aside className="posts-filter-sidebar" aria-label="Post filters">
      <div className="posts-filter-head">
        <h2>Filters</h2>
        {hasActiveFilter ? (
          <button type="button" className="posts-filter-clear" onClick={clearAll}>
            <X size={14} />
            Clear
          </button>
        ) : null}
      </div>

      <div className="posts-filter-section">
        <p className="posts-filter-label">Post type</p>
        <FilterSelect
          multiple
          value={filters.type}
          onChange={(type) => update("type", type)}
          options={TYPE_OPTIONS}
          placeholder="All posts"
        />
      </div>

      <div className="posts-filter-section">
        <p className="posts-filter-label">Activity</p>
        <FilterSelect
          multiple
          value={filters.activity}
          onChange={(activity) => update("activity", activity)}
          options={activityOptions}
          placeholder="All activities"
          loading={loadingActivities}
          searchable
          searchPlaceholder="Search activities..."
          menuClassName="posts-filter-menu"
        />
      </div>

      <div className="posts-filter-section">
        <p className="posts-filter-label">Class</p>
        <FilterSelect
          multiple
          value={filters.classroom}
          onChange={(classroom) => update("classroom", classroom)}
          options={classOptions}
          placeholder="All classes"
          loading={loadingClasses}
          searchable
          searchPlaceholder="Search classes..."
          menuClassName="posts-filter-menu"
        />
      </div>

      <div className="posts-filter-section">
        <p className="posts-filter-label">Student</p>
        <FilterSelect
          multiple
          value={filters.child}
          onChange={(child) => update("child", child)}
          options={childOptions}
          placeholder="All students"
          loading={loadingChildren}
          searchable
          searchPlaceholder="Search students..."
          menuClassName="posts-filter-menu"
        />
      </div>
    </aside>
  );
}

export default PostFeedFilters;
